const headers = document.querySelectorAll('[data-alfresco-nook-header]');

headers.forEach((header) => {
  const openBtn = header.querySelector('[data-alfresco-drawer-open]');
  const drawer = header.querySelector('[data-alfresco-drawer]');
  if (!openBtn || !drawer) return;

  const closeBtn = drawer.querySelector('[data-alfresco-drawer-close]');
  const backdrop = drawer.querySelector('[data-alfresco-drawer-backdrop]');
  const toggles = drawer.querySelectorAll('[data-alfresco-drawer-toggle]');
  let closeTimer;

  const onKeydown = (event) => {
    if (event.key === 'Escape') closeDrawer();
  };

  function openDrawer() {
    window.clearTimeout(closeTimer);
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('alfresco-nook-drawer-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
    window.setTimeout(() => closeBtn?.focus(), 50);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('alfresco-nook-drawer-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    openBtn.focus();
    closeTimer = window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 320);
  }

  openBtn.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  closeBtn?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const submenu = toggle.nextElementSibling;
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (submenu) submenu.hidden = isOpen;
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 960 && drawer.classList.contains('is-open')) closeDrawer();
  });
});
